import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const SolutionBanner = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="solution-banner-warp">
        <div className="solution-banner">
          <div className="banner-img">
            <img
              src={`//files.authing.co/authing-website/banner-solution.svg`}
              alt="authing solution banner"
            />
          </div>
          <div className="banner-content">
            <div className="banner-title">
              {t("solution.list.banner.title")}
            </div>
            <div className="banner-subtitle">
              {t("solution.list.banner.subtitle")}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
